import React, { useEffect, useState } from 'react'
import { Select, SelectItem, SelectPlaceholder } from '@/components/Select'
import { api } from '@/api'

const StateSelect = ({
  label = 'Регион:',
  theme = 'gray',
  valueType = 'id',
  ...props
}): React.ReactElement => {
  const [data, setData] = useState<any[]>([])

  useEffect(() => {
    api.getEducationRegions()
      .then((data) => {
        setData(data.results)
      })
      .catch(err => {
        console.log(err)
      })
  }, [])

  if (data.length === 0) {
    return (
      <SelectPlaceholder label={label} {...props} />
    )
  }

  return (
    <Select theme={theme} placeholder='Выбери' label={label} {...props}>
      {data.map((el) => {
        return (
          <SelectItem value={el} key={el}>
            {el}
          </SelectItem>
        )
      })}
    </Select>
  )
}

export default StateSelect
